"use strict";const substitutionRegExp=/{{([\w\d]+)}}/g,interpolate=(t,s)=>t.replace(substitutionRegExp,(t,e)=>s[e]);
/** Заменяет все значения через {{ }} соответствующими из пропертей объекта
 *
 * @param {string} str - строка, в которой содержатся названия полей объекта
 * @param {object} values - объект, в котором хранятся значения
*/module.exports=interpolate;
